import type { DomainMapper } from '../types';

const base = {
  countryCode: 'de',
  currency: 'EUR',
  dataAreaId: 'de20',
  environment: 'production',
  flagUrl: '/flags/DE.svg',
  languagePrimary: true,
  locale: 'de',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'produkt',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-de.xml',
  storyblokBasePath: 'de',
  algoliaIndex: 'b2b-de-de-DE-products',
  algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1355,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1355,
    algoliaIndex: 'b2b-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2b-de-de-DE-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-de.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1423,
    algoliaIndex: 'b2c-de-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-de-de-DE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-de-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    onlyAllowCustomerEditAddressesForSamples: true,
    disableShipToConsumer: true,
  },
  showNonPublicProducts: false,
};

const de: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default de;
